import React from "react";

import { Box, Flex } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { Step } from "../../../pages/Criancas/Movimentacao/Step";

export const HistoricoMovimentacao = ({ data, idCrianca }) => {
  const sortedData = data?.slice().sort((a, b) => b.ordem - a.ordem);
  return sortedData ? (
    <Box className="break-page">
      <Flex>
        <Group bgColor="#fff" title="Histórico de Movimentação">
          {sortedData.map((movimentacao, index) => (
            <Box className="break-page" key={index}>
              <Step
                print={true}
                key={index}
                step={sortedData.length - index}
                movimentacao={movimentacao}
                idCrianca={idCrianca}
                data={sortedData}
                movimentacaoAnterior={index}
                isLast={index === sortedData.length - 1}
                isFirst={index === 0}
              />
            </Box>
          ))}
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box>
      <Group
        bgColor="#fff"
        title="Histórico de Movimentação"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
